<template>
    <div class="vote">
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines u-f u-jsb" :inline="true">
                <div></div>
                <div>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">
                            新增
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <el-table :data="proData" border v-loading="loading" :height="height" class="tableLimit votebox">
            <el-table-column prop="vote_name" type="index" label="序号" width="80"></el-table-column>
            <el-table-column prop="privilege_title" label="标题" show-overflow-tooltip></el-table-column>
            <el-table-column prop="privilege_detail" label="详情" show-overflow-tooltip></el-table-column>
            <el-table-column prop="create_time" label="图片" width="150">
                <template slot-scope="scope">
                    <el-image style="width: 50px; height: 50px" :src="scope.row.file_info" :z-index='2034'
                        :preview-src-list="[scope.row.file_info]">
                    </el-image>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="200" align="center">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" icon="el-icon-edit-outline"
                        @click="handleEdit(scope.row,scope.$index)"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-delete"
                        @click="handleDelet(scope.row,scope.$index)"></el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog title="新建" :visible.sync="adddialogVisible" top="50px" width="50%" class="dialogs" append-to-body>
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="problems" ref="ruleForm" label-width="150px"
                    class="demo-ruleForm forms-lines">
                    <div class="problem_box">
                        <el-form-item label="标题" style="margin-top:10px" prop="privilege_title">
                            <el-input v-model="ruleForm.privilege_title" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="详情" style="margin-top:10px" prop="privilege_detail">
                            <el-input v-model="ruleForm.privilege_detail" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="特权编号" style="margin-top:10px" prop="privilege_code">
                            <el-input v-model="ruleForm.privilege_code" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="特权值" style="margin-top:10px" prop="privilege_value">
                            <el-input v-model="ruleForm.privilege_value" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="特权类型 " style="margin-top:10px" prop="privilege_type">
                            <el-input v-model="ruleForm.privilege_type" size="small" placeholder="1折扣 2数值 0无">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="图片" style="margin-top:10px" required>
                            <el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
                                :headers="{ token:$store.state.user.token }"
                                :data="{ image_class_id:'72',file_type:'1' }" :limit="1"
                                :file-list="ruleForm.lb_mapList" :on-success="uploadSuccess" :on-remove="uploadRmove"
                                list-type="picture-card">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">确 定
                </el-button>
                <el-button @click="adddialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                proData: [],
                textId: '',
                loading: false,
                subloading: false,
                height: null,
                adddialogVisible: false,
                ruleForm: {
                    privilege_title: '',
                    privilege_detail: '',
                    privilege_code: '',
                    privilege_value: '',
                    privilege_type: '',
                    lb_mapList: []
                },
                problems: {
                    privilege_title: [{
                        required: true,
                        message: '*必填',
                        trigger: 'blur'
                    }, ],
                    privilege_detail: [{
                        required: true,
                        message: '*必填',
                        trigger: 'blur'
                    }, ],
                    privilege_code: [{
                        required: true,
                        message: '*必填',
                        trigger: 'blur'
                    }, ],
                    privilege_value: [{
                        required: true,
                        message: '*必填',
                        trigger: 'blur'
                    }, ],
                    privilege_type: [{
                        required: true,
                        message: '*必填',
                        trigger: 'blur'
                    }, ],
                    lb_mapList: [{
                        required: true,
                        message: '*必上传',
                        trigger: 'blur'
                    }, ],


                },
                eid: '',

                mapListed: [],
            }
        },
        mounted() {
            this.getHeight()

        },
        methods: {
            getHeight() {
                let that = this

                that.height = window.innerHeight - 175 + 'px'
                window.onresize = () => {

                    that.height = window.innerHeight - 175 + 'px'
                }
            },
            handleAdd() {
                this.clearf()
                this.adddialogVisible = true
            },
            clearf() {
                this.eid = ''
                this.ruleForm = {
                    privilege_title: '',
                    privilege_detail: '',
                    privilege_code: '',
                    privilege_value: '',
                    privilege_type: '',
                    lb_mapList: []
                }
                this.mapListed = []
            },
            getlist(id) {
                // this.proData=[]
                this.loading = true
                axios
                    .post("/admin/pc/MedalPrivilege/medalPrivilegeList", {
                        level: id
                    }, {
                        token: true
                    })
                    .then(response => {
                        if (response.data.code == '200') {
                            this.proData = response.data.data.list
                        } else {
                            that.$message.error(response.data.msg);
                        }
                        this.loading = false
                    })
                    .catch(error => {
                        this.loading = false
                    })
            },
            handleEdit(row, index) {
                this.eid = row.id
                this.ruleForm = {
                    privilege_title: row.privilege_title,
                    privilege_detail: row.privilege_detail,
                    privilege_code: row.privilege_code,
                    privilege_value: row.privilege_value,
                    privilege_type: row.privilege_type,
                    lb_mapList: [{
                        url: row.file_info
                    }]
                }
                this.mapListed = [{
                    url: row.file_info
                }]
                this.adddialogVisible = true
            },
            handleDelet(row, index) {
                let that = this
                this.$confirm('此操作将永久删除该问题, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/pc/MedalPrivilege/delMedalPrivilege", {
                            id: row.id,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.getlist(this.textId)
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            submit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (that.mapListed.length == 0) return this.$message.error('请上传图片')
                        let urls = "/admin/pc/MedalPrivilege/addMedalPrivilege"
                        axios.post(urls, {
                                id: that.eid,
                                level: this.textId,
                                privilege_detail: this.ruleForm.privilege_detail,
                                privilege_code: this.ruleForm.privilege_code,
                                privilege_value: this.ruleForm.privilege_value,
                                privilege_title: this.ruleForm.privilege_title,
                                file_info: that.mapListed[0].url,
                                privilege_type: this.ruleForm.privilege_type,

                            }, {
                                token: true
                            })
                            .then(response => {
                                that.subloading = false
                                if (response.data.code == '200') {
                                    that.adddialogVisible = false
                                    that.getlist(this.textId)
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {
                                that.subloading = true
                            })
                    } else {
                        // this.$alert("信息遗漏未填")
                        return false;
                    }
                });
            },
            uploadSuccess(response, file, fileList) {
                let that = this
                if (response.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.msg)
                    return;
                }
                that.$message({
                    message: '上传成功',
                    type: 'success'
                });
                that.mapListed.push(response.data)
            },
            uploadRmove(file, fileList) {
                var index = this.mapListed.findIndex(item => item.id == file.id)
                this.mapListed.splice(index, 1)
            },
        },
    }
</script>

<style lang="scss" scoped>
    .add_tits {
        padding: 0 10px;
    }
</style>